export default "__VITE_ASSET__CMTsR7hS__"